import {momentDeLaJournee} from "../ambiance";

/**
 * Défilement parallaxe du fond « Voyageur » : les durées d'animation, calculées sans rien dessiner (donc testables).
 * Adapté de l'artéfact « Aerith Parallax » : chaque plan défile à une fraction de la vitesse du sol, plus il est loin plus
 * cette fraction est faible. Vitesses en pixels d'art par seconde ; un plan se répète tous les `periode` pixels d'art.
 */

/** Plans qui défilent, du plus lointain au plus proche (le ciel est fixe, le voyageur reste sur place). */
export const COUCHES = [
    {id: "nuages1", ratio: 0.03, derive: 1.5, periode: 512},
    {id: "montagnes", ratio: 0.06, derive: 0, periode: 512},
    {id: "nuages2", ratio: 0.10, derive: 3, periode: 512},
    {id: "collinesA", ratio: 0.14, derive: 0, periode: 512},
    {id: "collinesB", ratio: 0.25, derive: 0, periode: 512},
    {id: "foretArriere", ratio: 0.40, derive: 0, periode: 512},
    {id: "foretAvant", ratio: 0.62, derive: 0, periode: 512},
    {id: "sol", ratio: 1, derive: 0, periode: 512},
    {id: "herbes", ratio: 1.45, derive: 0, periode: 256},
];

/** Durée (secondes) pour qu'un plan avance d'une période, ou null s'il ne bouge pas. */
export function dureeCouche(couche, vitesse) {
    const v = vitesse * couche.ratio + couche.derive;
    return v > 0 ? couche.periode / v : null;
}

/** Pixels de sol parcourus pendant un cycle complet de pas : le voyageur court ou marche au rythme du sol. */
export const PIXELS_PAR_CYCLE = {courir: 20, marcher: 12};

/** Durée (secondes) d'un cycle de pas du voyageur à cette vitesse de sol. */
export function dureeCycle(allure, vitesse) {
    return PIXELS_PAR_CYCLE[allure] / Math.max(1, vitesse);
}

/** Ambiance selon l'heure, avec les horaires réglés dans le tableau de bord (voir ../ambiance.js) : « jour », « crepuscule » (le soir) ou « nuit ». */
export function ambianceSelonHeure(date, horaires) {
    return {jour: "jour", soir: "crepuscule", nuit: "nuit"}[momentDeLaJournee(date, horaires)];
}
